export const getFooterLinks = (dict: any) => {
  const sitemapLink =
    process.env.NEXT_PUBLIC_ENV === 'production' &&
    'https://smzh.ch/sitemap.xml';

  return {
    informativeCardContent: dict?.footer.informativeCardContent ?? '',
    navLinks: {
      firstSet: [
        {
          title: dict?.footer.services.title,
          links: dict?.footer.services.items.map((item: any) => ({
            children: item.label,
            href: item.href,
          })),
        },
      ],
      secondSet: [
        {
          title: dict?.footer.company.title,
          links: dict?.footer.company.items.map((item: any) => ({
            children: item.label,
            href: item.href,
          })),
        },
      ],
      thirdSet: [
        {
          title: '',
          links: [
            ...dict?.footer.legal.items.map((item: any) => ({
              children: item.label,
              href: item.href,
            })),
            ...(sitemapLink
              ? [{ children: 'Sitemap', href: sitemapLink }]
              : []),
          ],
        },
      ],
      fourthSet: [
        {
          title: '',
          links: [
            {
              children: dict?.footer.address,
              href: '#',
            },
          ],
        },
      ],
    },
    companyLogo: '/logo/smzh-logo.png',
  };
};
